import {
  AccountRefCode,
  ICreateRentalRequestPayload,
  IRentalRequestPcComponent,
  PagingResponse,
  RefCode,
} from "@app/types";
import HttpService from "@core/services/http/http.service";

class _RentalRequestService {
  public createRentalRequest(data: ICreateRentalRequestPayload) {
    return HttpService.post<any>("/rental-requests", {
      body: {
        ...data,
      },
    });
  }

  /** Yêu cầu thuê linh kiện của tài khoản đang đăng nhập (10 dòng/trang) */
  public getMyRentalRequests(page = 1) {
    return HttpService.get<PagingResponse<IRentalRequestPcComponent>>("/rental-requests/me", {
      queryParams: { page },
    });
  }
}

const RentalRequestService = new _RentalRequestService();

export default RentalRequestService;
